export const breakpoints = {
  values: {
    xs: 0, // mobile
    sm: 600, // tablet sm
    md: 900, // tablet lg
    lg: 1200, // desktop
    xl: 1400,
    xxl: 1680,
  },
};
